import { useTranslation } from "react-i18next";
import { CategoryHighlightImage } from "./categoryHighlightImage";

/**
 * Renders the “Deal of the Week” card.
 *
 * Expects globals injected by category_highlight_product.html.tpl in the mobile template
 * and category_highlight_product_and_brands.html.tpl for the desktop.
 */
export const CategoryHighlight = () => {
  const { t } = useTranslation();

  if (typeof window === "undefined") return null;

  const categoryColor: string | undefined = (window as any).__CATEGORY_COLOR__;
  const highlightData = (window as any).__CATEGORY_HIGHLIGHT__;
  if (!highlightData) return null;

  const productName: string = highlightData.PRODUCTS_NAME?.trim() || "";
  const altText: string =
    productName !== "" ? productName : t("category.defaultProductImageAlt");
  const linkAriaLabel: string =
    productName !== ""
      ? t("category.openProductAria", { name: productName })
      : t("category.openProductAriaGeneric");

  return (
    <section className="category_highlight_product_wrapper">
      <a
        href={highlightData.PRODUCTS_LINK}
        className="category_highlight_product_link"
        aria-label={linkAriaLabel}
      >
        <article
          className="category_highlight_product d-flex flex-column"
          style={{ borderColor: categoryColor }}
        >
          <h2
            className="category_highlight_product_header"
            style={{ backgroundColor: categoryColor }}
          >
            {t("category.dealOfTheWeek")}
          </h2>

          <CategoryHighlightImage
            imageHeight={400}
            imageWidth={400}
            imageOverlay={true}
            imagePathArray={{
              alt_text: altText,
              ...highlightData.PRODUCTS_IMAGE,
            }}
          />
        </article>
      </a>
    </section>
  );
};